import React, { useState, useEffect } from "react";
import { View, Modal, TouchableNativeFeedback, Image } from "react-native";
import Text from "@components/CustomText";
import CrossIcon from "@assets/svg/CrossIcon";
import { openSettings } from "react-native-permissions";
import { useSelector, useDispatch } from "react-redux";
import { actions as miscActions } from "@reducers/miscReducer";
import t from "@constants/localization";
import Button from "./Components/Button";

import styles from "./styles";

const PATH = "screens/LocationServiceablity/OpenSettings";

const CrossBtn = ({ onPress }) => {
  return (
    <TouchableNativeFeedback onPress={onPress}>
      <View style={{ padding: 6 }}>
        <CrossIcon />
      </View>
    </TouchableNativeFeedback>
  );
};

const OpenSettings = (props) => {
  const dispatch = useDispatch();
  const { settingsModal } = useSelector((s) => s.misc);

  const closeModalHandler = () => {
    dispatch(miscActions.hideSettingsModal());
  };
  return (
    <Modal
      visible={settingsModal}
      onRequestClose={closeModalHandler}
      transparent
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.7)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            elevation: 2,
            width: "87%",
          }}
        >
          <View
            style={{
              paddingHorizontal: 15,
              flexDirection: "row",
              justifyContent: "space-between",
              paddingTop: 15,
              marginBottom: 15,
            }}
          >
            <View>
              <Text
                style={{
                  fontFamily: "NotoSansDevanagari-Bold",
                  fontSize: 16,
                  lineHeight: 24,
                }}
              >
                {t(`${PATH}/goToSettings`)}
              </Text>
              <Text
                style={{
                  fontFamily: "NotoSansDevanagari-Bold",
                  fontSize: 16,
                  lineHeight: 24,
                }}
              >
                {t(`${PATH}/givePermission`)}
              </Text>
            </View>
            <CrossBtn onPress={closeModalHandler} />
          </View>
          <View
            style={{
              paddingHorizontal: 15,
              //   backgroundColor: "blue",
            }}
          >
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628004206843perms3x.png",
              }}
              resizeMode="contain"
              style={{ width: "100%", height: undefined, aspectRatio: 1.5 }}
            />
          </View>
          <Button
            btnText={t(`${PATH}/giveLocationPermission`)}
            style={[styles.btnStyle, { width: "100%" }]}
            onPress={() =>
              openSettings().catch(() => console.log("cannot open settings"))
            }
            contentContainerStyle={{
              alignItems: "center",
              marginTop: 20,
              paddingHorizontal: 15,
              marginBottom: 30,
            }}
          />
        </View>
      </View>
    </Modal>
  );
};

export default OpenSettings;
